// Material Kit 2 PRO React pages
import Publications from "pages/publications";

export default function PublicationsPage() {
  return <Publications />;
}